import { apiClient } from '../../axios';
import {
  GetVipTierBenefitsResponse,
  PostVipApplicationParams,
  PostVipApplicationResponse,
  PostVipSourceOfProofParams,
  PostVipSourceOfProofResponse,
} from './types';

export const getVipTierBenefitsApi = () => apiClient.get<GetVipTierBenefitsResponse>('/v1/vip/tier-benefits');

export const postVipSourceOfProofApi = (params: PostVipSourceOfProofParams) =>
  apiClient.post<PostVipSourceOfProofResponse>('/v1/user/vip/source-of-proof', params);

export const postVipApplicationApi = (params: PostVipApplicationParams) =>
  apiClient.post<PostVipApplicationResponse>('/v1/user/vip/application', params);
